import { render, staticRenderFns } from "./ProgramTemplateCriteria.vue?vue&type=template&id=6b419515&scoped=true&"
import script from "./ProgramTemplateCriteria.vue?vue&type=script&lang=js&"
export * from "./ProgramTemplateCriteria.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTemplateCriteria.vue?vue&type=style&index=0&id=6b419515&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b419515",
  null
  
)

export default component.exports